export enum FormState {
  Default,
  Loading,
  Success,
  Failed,
}
